import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import ClubDetailPage from '../pages/ClubDetailPage';
import PublishersPage, { PublisherDetailPage } from '../pages/PublishersPage';
import PlayersPage, { PlayerDetailPage } from '../pages/PlayersPage';
import AdminPage   from '../pages/AdminPage';
import ProfilePage from '../pages/ProfilePage';
import { ClubsPage, EventsPage, EventDetailPage, NewsPage, NewsDetailPage, CalendarPage, LocationsPage, LarpPage, WorldEventsPage } from '../pages/OtherPages';
import { AboutPage, ContactPage, PrivacyPage, TermsPage, PricingPage, MediaKitPage, VerifyEmailPage } from '../pages/InfoPages';
import WishlistPage from '../pages/WishlistPage';
import ListingsPage, { ListingDetailPage } from '../pages/ListingsPage';
import OAuthDonePage from '../pages/OAuthDonePage';
import RegisterPage from '../pages/RegisterPage';
import { ContestsPage, PollsPage, TravelPage } from '../pages/CommunityPages';

export default function Body() {
  return (
    <main>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/clubs" element={<ClubsPage />} />
        <Route path="/clubs/:id" element={<ClubDetailPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/world" element={<WorldEventsPage />} />
        <Route path="/events/:id" element={<EventDetailPage />} />
        <Route path="/larp" element={<LarpPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/publishers" element={<PublishersPage />} />
        <Route path="/publishers/:id" element={<PublisherDetailPage />} />
        <Route path="/players"    element={<PlayersPage />} />
        <Route path="/players/:id" element={<PlayerDetailPage />} />
        <Route path="/about"      element={<AboutPage />} />
        <Route path="/contact"    element={<ContactPage />} />
        <Route path="/privacy"    element={<PrivacyPage />} />
        <Route path="/terms"      element={<TermsPage />} />
        <Route path="/pricing"    element={<PricingPage />} />
        <Route path="/media-kit"  element={<MediaKitPage />} />
        <Route path="/wishlist"     element={<WishlistPage />} />
        <Route path="/skelbimai"    element={<ListingsPage />} />
        <Route path="/skelbimai/:id" element={<ListingDetailPage />} />
        <Route path="/konkursai"    element={<ContestsPage />} />
        <Route path="/balsavimai"   element={<PollsPage />} />
        <Route path="/planuokle"    element={<TravelPage />} />
        <Route path="/oauth-done"   element={<OAuthDonePage />} />
        <Route path="/register"     element={<RegisterPage />} />
        <Route path="/admin"        element={<AdminPage />} />
        <Route path="/profile"      element={<ProfilePage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
      </Routes>
    </main>
  );
}
